var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "svg",
      {
        attrs: {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c("rect", {
          attrs: {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "19",
            rx: "9.5",
            stroke: "#B3B3B3",
          },
        }),
        _c("path", {
          attrs: {
            d: "M12.0141 6L12.0817 7.05307C9.64226 7.09717 8.38592 8.15575 8.11549 9.84837C8.48169 9.23088 9.39437 8.82288 10.4028 8.82288C12.0817 8.82288 13 9.9421 13 11.3425C13 13.0131 11.6817 14 10.0986 14C8.45352 14 7 12.9304 7 10.5045C7 7.68711 8.96057 6.04962 12.0141 6ZM10.1211 12.969C11.0676 12.969 11.8507 12.4452 11.8507 11.3921C11.8507 10.4383 11.2141 9.79877 10.1718 9.79877C9.18592 9.79877 8.29578 10.3556 8.29578 11.3756C8.29578 12.3129 9.06198 12.969 10.1211 12.969Z",
            fill: "#666666",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }